module.exports = __webpack_public_path__ + "static/media/Panther460_4c.323f6d50.svg";